import React from 'react';
import { trackEvent } from '../firebase/analytics';
import { ANALYTICS_EVENTS } from '../firebase/analyticsEvents';
import './InfoModal.css';

const InfoModal = ({ isOpen, onClose, title, content, modalType }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    trackEvent(ANALYTICS_EVENTS.MODAL_CLOSE_CLICK, {
      modal_type: modalType,
      timestamp: Date.now()
    });
    onClose();
  };

  return (
    <div className="info-modal-overlay" onClick={handleClose}>
      <div className="info-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="info-modal-header">
          <h2>{title}</h2>
          <button className="info-modal-close" onClick={handleClose}>×</button>
        </div>
        <div className="info-modal-body">
          {content}
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
